import { getDataAPI, postDataAPI, postDataAPIWithToken } from "../../../helper/api";

export const requestGetProviderCategories = () => {
	return getDataAPI("/api/provider/categories");
};

export const requestGetproviderSearchData = payload => {
	return postDataAPI("/api/provider/searchMaskedProviderForLinkdin", { ...payload });
};

export const requestGetproviderSearchDataWithToken = payload => {
	return postDataAPIWithToken("/api/provider/searchMaskedFilteredProvider", { ...payload });
};